import isEmpty from 'lodash/isEmpty';

const invalidValues = ['', null, undefined];

export const filterInvalidValuesFormValues = (formValues) => {
  let result = {};

  for (const [key, value] of Object.entries(formValues)) {
    if (Array.isArray(value)) {
      if (
        value.length === 0 ||
        value.some((item) => invalidValues.includes(item))
      ) {
        result = {
          ...result,
          [key]: value.filter((item) => !invalidValues.includes(item)),
        };
      } else {
        result = {
          ...result,
          [key]: value,
        };
      }
    } else {
      result = {
        ...result,
        [key]: value,
      };
    }
  }

  return result;
};

export const checkPassedRequirementProduct = (minimumRequirements) => {
  const isEmptyRequirements = isEmpty(minimumRequirements);
  const isMatchedRequirements = Boolean(minimumRequirements?.matched);

  return isEmptyRequirements || isMatchedRequirements;
};

const getFullPathDisplayName = ({ parentDisplayFullName, displayName }) => {
  const fullPathDisplayName = `${parentDisplayFullName}${
    parentDisplayFullName && displayName ? ' - ' : ''
  }${displayName}`;

  return fullPathDisplayName;
};

const flattenField = ({
  properties,
  mappingFieldFn = () => {},
  mappingModuleFn = () => {},
  moduleField,
  parentDisplayFullName = '',
}) => {
  let result = {};

  for (const field of properties) {
    const { fieldFullPath, properties: childProperties } = field;

    const fullPathDisplayName = getFullPathDisplayName({
      parentDisplayFullName,
      displayName: field?.displayName,
    });

    result = {
      ...result,
      [fieldFullPath]: {
        ...field,
        fullPathDisplayName,
        ...mappingFieldFn(field),
        ...mappingModuleFn(moduleField),
      },
      ...flattenField({
        properties: childProperties,
        mappingFieldFn,
        mappingModuleFn,
        moduleField,
        parentDisplayFullName: fullPathDisplayName,
      }),
    };
  }

  return result;
};

const defaultMappingModuleFn = (moduleField) => ({
  moduleDisplayName: moduleField.displayName,
  moduleName: moduleField.moduleName,
});

const defaultMappingFieldFn = () => ({});

export const flattenRequiredProductFields = ({
  allFields = [],
  mappingFieldFn = defaultMappingFieldFn,
  mappingModuleFn = defaultMappingModuleFn,
}) => {
  let result = {};

  for (const moduleField of allFields) {
    result = {
      ...result,
      ...flattenField({
        properties: moduleField.properties,
        mappingFieldFn,
        mappingModuleFn,
        moduleField,
        parentDisplayFullName: '',
      }),
    };
  }

  return result;
};
